module.exports = __webpack_public_path__ + "static/media/mobile-android.83837e4e.svg";